/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：262
 */

"use strict"

export { IconWidgetWebView as a }
export { o as c }
export { i as b }
export { a as e }
export { s as d }
var /* [auto-meaningful-name] */IconWidgetWebView = "icon-widget-web-view"
var o = 40
var i = 40
var a = false
var s = false
export default IconWidgetWebView
